'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.REVIEW_CODE_CHANGE = exports.REVIEW_BODY_CHANGE = exports.SUBMIT_BUTTON_CLICKED = exports.SUBMIT_ATTEMPTED = exports.SET_STAR_ACTIVE = exports.NEXT_BUTTON_CLICKED = exports.VALIDATE_CODE = exports.AGREE_BUTTON_CLICKED = exports.CLOSE_REVIEW_MODAL = exports.OPEN_REVIEW_MODAL = undefined;

var _doctifyUtils = require('doctify-utils');

var OPEN_REVIEW_MODAL = exports.OPEN_REVIEW_MODAL = 'REVIEW_MODAL:OPEN_REVIEW_MODAL';

var CLOSE_REVIEW_MODAL = exports.CLOSE_REVIEW_MODAL = 'REVIEW_MODAL:CLOSE_REVIEW_MODAL';
var AGREE_BUTTON_CLICKED = exports.AGREE_BUTTON_CLICKED = 'REVIEW_MODAL:AGREE_BUTTON_CLICKED';
var VALIDATE_CODE = exports.VALIDATE_CODE = 'REVIEW_MODAL:VALIDATE_CODE';
var NEXT_BUTTON_CLICKED = exports.NEXT_BUTTON_CLICKED = 'REVIEW_MODAL:NEXT_BUTTON_CLICKED';
var SET_STAR_ACTIVE = exports.SET_STAR_ACTIVE = 'REVIEW_MODAL:SET_STAR_ACTIVE';
var SUBMIT_ATTEMPTED = exports.SUBMIT_ATTEMPTED = 'REVIEW_MODAL:SUBMIT_ATTEMPTED';
var SUBMIT_BUTTON_CLICKED = exports.SUBMIT_BUTTON_CLICKED = 'REVIEW_MODAL:SUBMIT_BUTTON_CLICKED';
var REVIEW_BODY_CHANGE = exports.REVIEW_BODY_CHANGE = 'REVIEW_MODAL:REVIEW_BODY_CHANGE';
var REVIEW_CODE_CHANGE = exports.REVIEW_CODE_CHANGE = 'REVIEW_MODAL:REVIEW_CODE_CHANGE';

var ReviewModalActions = {
	openReviewModal: function openReviewModal() {
		return {
			type: OPEN_REVIEW_MODAL
		};
	},
	closeModal: function closeModal() {
		return {
			type: CLOSE_REVIEW_MODAL
		};
	},
	agreeButtonClicked: function agreeButtonClicked() {
		return {
			type: AGREE_BUTTON_CLICKED
		};
	},
	validateCode: function validateCode(code) {
		return (0, _doctifyUtils.createAction)({
			actionType: VALIDATE_CODE,
			url: 'reviews/codes/' + code,
			method: 'GET',
			actionData: code
		});
	},
	nextButtonClicked: function nextButtonClicked() {
		return {
			type: NEXT_BUTTON_CLICKED
		};
	},
	setStarActive: function setStarActive(rating) {
		return {
			type: SET_STAR_ACTIVE,
			rating: rating
		};
	},
	submitFailed: function submitFailed() {
		return {
			type: SUBMIT_ATTEMPTED
		};
	},
	submitButtonClicked: function submitButtonClicked(data, type) {
		return (0, _doctifyUtils.createAction)({
			actionType: SUBMIT_BUTTON_CLICKED,
			url: type + 's/' + data.id + '/reviews',
			method: 'POST',
			data: data
		});
	},
	onReviewBodyChange: function onReviewBodyChange(body) {
		return {
			type: REVIEW_BODY_CHANGE,
			body: body
		};
	},
	onReviewCodeChange: function onReviewCodeChange(code) {
		return {
			type: REVIEW_CODE_CHANGE,
			code: code
		};
	}
};

exports.default = ReviewModalActions;